import {pluckResult, ProductManagementApiService} from './product-management-api.service';
import {HttpClient} from '@angular/common/http';
import {Injectable, Signal} from '@angular/core';
import {Store} from '@ngrx/store';
import {toSignal} from '@angular/core/rxjs-interop';
import {selectSelectedOrganizationId} from '../state/router/router.selectors';
import {ApiResponse, CatalogMembership, CatalogMembershipRequest} from '../models/clare';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class CatalogMembershipApiService extends ProductManagementApiService {
  controllerPath = 'catalog_memberships';

  organizationId: Signal<string | undefined>;

  constructor(
    protected override http: HttpClient,
    private store: Store
  ) {
    super(http);

    this.organizationId = toSignal(this.store.select(selectSelectedOrganizationId));
  }

  assign(membership: CatalogMembershipRequest): Observable<CatalogMembership> {
    const url = this.getUrl();
    return this.POST<ApiResponse<CatalogMembership>>(url, membership, this.requestOptions()).pipe(pluckResult());
  }

  remove(membership: CatalogMembershipRequest): Observable<CatalogMembership> {
    const url = this.getUrl();
    return this.DELETE<ApiResponse<CatalogMembership>>(url, {...this.requestOptions(), body: membership}).pipe(
      pluckResult()
    );
  }

  protected override getUrl(path = ''): string {
    return `${environment.apiBaseUrl}/finance/organizations/${this.organizationId()}/${this.controllerPath}/${path}`;
  }
}
